import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var SchemeListRes;
export const SchemeListTodo = createAsyncThunk('SchemeList', async (data) => {
    // console.log("data", data)
    const type = localStorage.getItem('type')
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'scheme_List',
            data:{
                "ibusiness_area_id": localStorage.getItem('ibusiness_area_id')
            },
            headers: { "Content-Type": "application/json" },
       
        })
        return SchemeListRes = res.data

    } catch (error) {
        return SchemeListRes = error.response.data
    }
});

const SchemeListSlice = createSlice({
    name: 'SchemeList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(SchemeListTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('userList', state.data)
        });
        builder.addCase(SchemeListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default SchemeListSlice.reducer; 